module.exports = __webpack_public_path__ + "img/law1-m@2.31e0a63a.jpg";